import styled from 'styled-components';

export const DashboardPageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DashboardContentWrapper = styled.div`
  width: calc(100% - 48px);
  height: 100%;
  padding: 24px;
`;

export const DashboardSystemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 40px;
`;
